import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/admin.css";

const API_BASE_URL = "/api";

function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (!email.trim()) {
      setError("لطفاً ایمیل پنل مدیریت را وارد کنید.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${API_BASE_URL}/staff/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.trim(),
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setError(data.message || "خطا در ارسال لینک بازیابی رمز عبور.");
        return;
      }

      setMessage(data.message || "لینک بازیابی رمز عبور به ایمیل ارسال شد.");
      setEmail("");
    } catch (err) {
      console.error("Forgot password request error:", err);
      setError("ارتباط با سرور برقرار نشد.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="staff-auth-page admin-auth-page">
      <div className="staff-auth-card admin-login-card">
        <div className="admin-login-header">
          <span className="admin-badge">پنل مدیریت</span>
          <h2>فراموشی رمز عبور پنل مدیریت</h2>
          <p>
            ایمیل حساب مدیریتی خود را وارد کنید تا لینک بازیابی رمز عبور برای
            شما ارسال شود.
          </p>
        </div>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>ایمیل</label>
            <input
              type="email"
              placeholder="ایمیل پنل مدیریت"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              dir="ltr"
            />
          </div>

          <button type="submit" className="auth-submit-btn" disabled={loading}>
            {loading ? "در حال ارسال..." : "ارسال لینک بازیابی"}
          </button>
        </form>

        <Link to="/admin/login" className="staff-auth-link admin-back-btn">
          بازگشت به صفحه ورود پنل مدیریت
        </Link>
      </div>
    </div>
  );
}

export default AdminForgotPassword;
